var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_43573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_43573)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_43573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 106C82.2711 106 106 82.2711 106 53C106 23.7289 82.2711 0 53 0C23.7289 0 0 23.7289 0 53C0 82.2711 23.7289 106 53 106Z",
    fill: "#FFE2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8499 60.8409C30.1295 58.0294 28.077 55.5235 25.2655 55.2438C22.454 54.9642 19.9481 57.0167 19.6684 59.8282C19.3888 62.6398 21.4413 65.1456 24.2528 65.4253C27.0644 65.7049 29.5702 63.6524 29.8499 60.8409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1958 63.9544C88.1937 61.9565 88.1937 58.7173 86.1958 56.7195C84.198 54.7216 80.9588 54.7216 78.961 56.7195C76.9631 58.7173 76.9631 61.9565 78.961 63.9544C80.9588 65.9522 84.198 65.9522 86.1958 63.9544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67 103.831C36.7314 103.831 22.9514 90.0508 22.9514 73.1144V41.6356C22.9514 24.6991 36.7314 10.917 53.67 10.917C70.6086 10.917 84.3886 24.6991 84.3886 41.6356V73.1144C84.3886 90.0508 70.6086 103.831 53.67 103.831Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4083 121.394L26.8899 118.33L43.8135 93.3651C44.2201 92.7665 44.8477 92.3538 45.5584 92.2177C46.2691 92.0816 47.0048 92.2332 47.6038 92.6391C47.9006 92.8401 48.1548 93.0976 48.3521 93.3969C48.5493 93.6962 48.6856 94.0314 48.7532 94.3834C48.8208 94.7354 48.8184 95.0973 48.7461 95.4484C48.6738 95.7994 48.5331 96.1328 48.3319 96.4294L31.4083 121.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7402 103.308L48.3314 96.4386C48.7389 95.8394 48.8917 95.1029 48.7562 94.391C48.6206 93.6792 48.2079 93.0504 47.6087 92.6429C47.0095 92.2354 46.273 92.0826 45.5612 92.2182C44.8494 92.3537 44.2205 92.7664 43.813 93.3656L43.7402 103.308Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8764 121.394L81.3948 118.33L64.0279 93.4894C63.827 93.1926 63.5695 92.9384 63.2702 92.7412C62.9709 92.5439 62.6357 92.4076 62.2837 92.34C61.9317 92.2724 61.5698 92.2748 61.2187 92.3471C60.8677 92.4194 60.5343 92.5602 60.2376 92.7614C59.9408 92.9625 59.6865 93.2202 59.4892 93.5197C59.292 93.8192 59.1556 94.1546 59.088 94.5068C59.0204 94.8589 59.0228 95.221 59.0952 95.5722C59.1675 95.9234 59.3083 96.257 59.5096 96.5538L76.8764 121.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6726 13.2246H53.6704C37.9859 13.2246 25.271 25.9395 25.271 41.624V55.8109C25.271 71.4955 37.9859 84.2103 53.6704 84.2103H53.6726C69.3571 84.2103 82.072 71.4955 82.072 55.8109V41.624C82.072 25.9395 69.3571 13.2246 53.6726 13.2246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3886 47.9224V42.2006C84.3886 24.4954 69.6878 10.0066 52.0104 10.9509C35.8406 11.8075 22.9514 25.2449 22.9514 41.6245V48.3165C22.9514 48.3464 65.2315 48.1023 65.2315 48.1023L68.677 40.4254L73.6644 47.9888L84.2451 47.9374C84.2451 47.9374 84.3886 48.006 84.3886 47.9224Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8323 61.833C36.8323 69.9383 44.3679 76.5081 53.6616 76.5081C62.9554 76.5081 70.4889 69.9383 70.4889 61.833H36.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.732 58.574C43.1649 58.5712 42.6219 58.3447 42.2209 57.9437C41.8199 57.5427 41.5934 56.9997 41.5906 56.4326V54.6981C41.5934 54.131 41.8199 53.5879 42.2209 53.187C42.6219 52.786 43.1649 52.5595 43.732 52.5566C44.2991 52.5595 44.8421 52.786 45.2431 53.187C45.6441 53.5879 45.8706 54.131 45.8734 54.6981V56.4326C45.8706 56.9997 45.6441 57.5427 45.2431 57.9437C44.8421 58.3447 44.2991 58.5712 43.732 58.574Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0838 58.574C62.5167 58.5712 61.9737 58.3447 61.5727 57.9437C61.1717 57.5427 60.9452 56.9997 60.9424 56.4326V54.6981C60.9452 54.131 61.1717 53.5879 61.5727 53.187C61.9737 52.786 62.5167 52.5595 63.0838 52.5566C63.6509 52.5595 64.1939 52.786 64.5949 53.187C64.9959 53.5879 65.2224 54.131 65.2252 54.6981V56.4326C65.2224 56.9997 64.9959 57.5427 64.5949 57.9437C64.1939 58.3447 63.6509 58.5712 63.0838 58.574Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.077 90.6953H58.7133C60.4404 90.6953 62.0968 91.3814 63.318 92.6026C64.5393 93.8239 65.2254 95.4802 65.2254 97.2073V111.983H42.5649V97.2073C42.5649 96.3522 42.7334 95.5054 43.0606 94.7153C43.3879 93.9252 43.8676 93.2073 44.4723 92.6026C45.077 91.9979 45.7949 91.5183 46.5849 91.191C47.375 90.8638 48.2218 90.6953 49.077 90.6953Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9209 78.3193H59.9878V90.0136C59.9878 91.612 59.3534 93.1451 58.224 94.2761C57.0945 95.4071 55.5624 96.0437 53.964 96.046C53.1718 96.046 52.3874 95.8899 51.6555 95.5868C50.9236 95.2836 50.2586 94.8393 49.6984 94.2791C49.1383 93.719 48.6939 93.054 48.3908 92.3221C48.0876 91.5902 47.9316 90.8058 47.9316 90.0136V78.3193H47.9209Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_43573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv5);
export default __webpack_public_path__ + "static/media/Av5.af0be6d14a8e17da0a5a2104b4a84e41.svg";
export { ForwardRef as ReactComponent };